(function(jQuery, Drupal) {
  'use strict';
  Drupal.behaviors.smooth_scroll = {
    attach: function(context, settings) {
      // *only* if we have anchor on the url
      if (window.location.hash) {
        var offset = -120;
        // smooth scroll to the anchor id
        jQuery('html, body').animate({
          scrollTop: (jQuery(window.location.hash).offset().top + offset) + 'px'
        }, 500, 'swing');
      }

      const smoothScrollInit = function() {
        const $body = jQuery(document, context);
        // Conditional will omit this JS on term and SKU listing pages
        if (!$body.hasClass('page-node-type-term-page') && !$body.hasClass('page-node-type-sku-listing')) {
          jQuery('a[href^="#"]', context).once('smooth-scroll').click(function(event) {
            const $link = jQuery(this);
            const target = $link.attr('href');
            event.preventDefault();
            if (!$link.hasClass('widget-accordion') && !$link.attr('no-smooth-scroll')) {
              if (target === '#') {
                jQuery('html, body').animate({
                  scrollTop: 0}, 500);
              }
              else {
                const $target = jQuery(target);
                if ($target.length > 0) {
                  const headerOffset = jQuery('.global-header').height();
                  jQuery('html, body').animate({
                    scrollTop: $target.offset().top - headerOffset
                  }, 500);
                  $target.focus();
                }
              }
            }
          });
        }
      };

      // Initialize smoothScrollInit when the DOM is ready
      smoothScrollInit();
    }
  };
})(jQuery, Drupal);